<template>
  <div class="license-plate noselect" >   
    
    <!-- <transition name="slide"> -->
      <van-popup v-model="show_keyboard" round position="bottom" class="keyboard-wrap" >
        <div class="cph-box">
          <div class="numtitle">请输入车牌号</div>
          <div class="cph-wrap cph-wrap-shadow">
              <span :class="[{active: (clickIndex) == index},{province: index==0},{city: index==1}]"
                    v-for="(item, index) in shadow"
                    :key="index"
                    @click="cphInputClick(index)">
                {{ cph[index] || (index === 7 ? '+' : '') }}
              </span>
          </div>
        </div>
        <div  @click="clickBoard" style="margin-bottom: 20px;">
          <!--=====   头部  =====-->
          <div class="keyboardHeader">
            <div>
                <span class="specials" :class="{'kspecials': activeIndex < 6}" v-for="(item,index) in specials"
                      :key="index">{{ item }}</span>
            </div>
            <div class="close">
              <span class="kclose" @click="closeKeyboard">完成</span>
            </div>
          </div>
          <!--=====   省  =====-->
          <div v-if="activeIndex === 0">
            <div class="keyboard">
                <span @touchstart="touchstart" @touchend="touchend" v-for="(item, index) in provice.slice(0,10)"
                      :key="index">{{ item }}</span>
            </div>
            <div class="keyboard">
                <span @touchstart="touchstart" @touchend="touchend" v-for="(item, index) in provice.slice(10,19)"
                      :key="index">{{ item }}</span>
            </div>
            <div class="keyboard">
                <span @touchstart="touchstart" @touchend="touchend" v-for="(item, index) in provice.slice(19,26)"
                      :key="index">{{ item }}</span>
            </div>
            <div class="keyboard">
                <span @touchstart="touchstart" @touchend="touchend" v-for="(item, index) in provice.slice(26)"
                      :key="index">{{ item }}</span>
              <span @touchstart="touchstart" @touchend="touchend" class="k-del">删</span>
            </div>
          </div>
          <!--=====   英文数字  =====-->
          <div v-else>
            <div class="keyboard">
                <span @touchstart="touchstart" @touchend="touchend" v-for="(item, index) in numbers" :key="index">
                  {{item }}</span>
            </div>
            <div class="keyboard">
                <span @touchstart="touchstart" @touchend="touchend" v-for="(item, index) in letters.slice(0,10)" :class="ioclass(index)"
                      :key="index">{{ item }}</span>
            </div>
            <div class="keyboard">
                <span @touchstart="touchstart" @touchend="touchend" v-for="(item, index) in letters.slice(10,19)"
                      :key="index">{{ item }}</span>
            </div>
            <div class="keyboard">
              <!-- <span @touchstart="touchstart" @touchend="touchend" class="k-done k-done2">完成</span> -->
              <span @touchstart="touchstart" @touchend="touchend" v-for="(item, index) in letters.slice(19)"
                    :key="index">{{ item }}</span>
              <span @touchstart="touchstart" @touchend="touchend" class="k-del">删</span>
            </div>
          </div>
        </div>
    </van-popup>
    <!-- </transition> -->
  </div>
 
</template>

<script>

export default {
  name: 'license-plate',
  props: {
    plateNumber: {
      type: Array,
      default: new Array(8)
    },
    idx: {
      type: Number,
      default: 0
    },
    value: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      carNumber: '',
      showWin: this.show,
      provice: [
        '京','沪','粤','津','冀','晋','蒙','辽','吉','黑',
        '苏','浙','皖','闽','赣','鲁','豫','鄂','湘',
        '桂','琼','渝','川','贵','云','藏',
        '陕','甘','青','宁','新','使'
      ],
      // provice: [
      //   '川','鄂','甘','赣','贵','桂','黑','沪','吉','冀',
      //   '津','晋','京','辽','鲁','蒙','闽','宁','青',
      //   '琼','陕','苏','皖','湘','新','渝',
      //   '豫','粤','云','藏','浙','使'
      // ],
      numbers: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '0'],
      letters: [
        'Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P',
        'A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L',
        'Z', 'X', 'C', 'V', 'B', 'N', 'M'
      ],
      // letters: [
      //   'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J',
      //   'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S',
      //   'T', 'U', 'V', 'W', 'X', 'Y', 'Z'
      // ],
      specials: ['领', '警', '港', '澳', '学', '挂'],
      cph: [],
      newCph: [],
      shadow: new Array(8),
      show_keyboard: this.value,
      clickIndex: 0,
      isOk: false
    };
  },
  watch: {
    value: function (val) {
      this.show_keyboard = val;
    },
    plateNumber: function (val) {
      this.cph = this.newCph = val;
      this.clickIndex = this.cph.length > 7 ? 7 : (this.cph.length == 7 ? 6 : this.cph.length);
      this.show_keyboard = true;
    },
  },
  methods: {
    closeKeyboard(){
      this.show_keyboard = false;
      var cphLength = this.cph.join('').replace(/\s*/g, "").length;
      if(cphLength<7)
      {
          this.$toast("车牌号码"+(this.idx+1)+" 格式不正确");
      }
    },
    confirmBtnFn() {
      var result={plateNumber:'',idx:''};
      var plateNumber = this.cph.join('');
      plateNumber = plateNumber.replace(/\s*/g, "");
      result.plateNumber = plateNumber;
      result.idx = this.idx;
      this.$emit('confirmBtnFn', result);
      // this.$emit('confirmBtnFn', this.cph.join(''));
    },
    clickBoard(e) {
      if (e.target.tagName.toLowerCase() === 'span') {
        if (e.target.className.indexOf('k') === -1 && this.clickIndex < 9) {
          this.cph[this.clickIndex] = e.target.textContent;
          this.newCph = this.cph;
          this.clickIndex += 1;
          if(this.clickIndex==7)
          {
            this.clickIndex = 6;
          }
          if (this.clickIndex > 7) this.clickIndex = 7;
          
        } else if (e.target.className === 'k-del') {
          if(this.newCph[this.clickIndex] && (this.clickIndex==6 || this.clickIndex==7))
          {
              this.clickIndex += 1;
          }          
          this.newCph[this.clickIndex-1] = '';
          this.cph = this.newCph;
          
          this.clickIndex = this.cph.join('').replace(/\s*/g, "").length;
          if (this.clickIndex < 0) this.clickIndex = 0;          
        } //else if (e.target.className.indexOf('k-done2') !== -1) {
          this.confirmBtnFn();
        //}
      }
    },
    cphInputClick(i) {
      var cphLength = this.cph.join('').replace(/\s*/g, "").length;
      if(cphLength==7 && i==7)
      {        
        this.clickIndex = i;
      }
    },
    touchstart(e) {
      e.target.classList.add('active_key');
    },
    touchend(e) {
      e.target.classList.remove('active_key');
    },
    ioclass(index){
      if(index == 7)
        return 'k-kspecials';
      else if(index == 8 && this.activeIndex>1)
        return 'k-kspecials';
      else
        return '';
    },
  },
  computed: {
    activeIndex() {
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.isOk = this.cph.length >= 6 && !this.cph.filter((item, index) => index < 6).includes('');
      return this.clickIndex;
    }
  }
};
</script>

<style scoped lang="scss">
.popTop {
  position: relative;

  .popTitle {
    font-size: 14px;
    padding: 10px;
  }

  .close {
    position: absolute;
    top: 0;
    right: 0;
  }
}

.popContent {
  box-sizing: border-box;
  padding: 20px;
  min-height: 125px;
  display: flex;
  justify-content: center;
}

.popFooter {
  display: flex;

  .btn {
    font-size: 14px;
    color: #222222;
    flex: 1;
    padding: 14px 0;
    background: #EFEFEF;
    font-weight: bold;
  }

  .cancelBtn {
    flex: 1;
  }

  .confirmBtn {
    flex: 1;
    background: #FF2343;
    color: #fff;
  }
}

.license-plate {
  padding: 10px;
  .cph-wrap {
    display: flex;
    // justify-content: flex-start;
    justify-content: center;
    font-size: 18px;
    line-height: 36px;
    min-height: 36px;
    .active {
      width: 29.5px;
      height: 36px;
      background-color: #f2f3f5;
      border-color: #845f56;
    }

    .province{      
      //border-right: none;
      margin-right: 0px;
    }
    
    .city{
      //border-left: none;
      margin-right: 10px;
    }
  }

  .cph-wrap-shadow {
    // background-color: #fff;
    z-index: 0;
    margin: 0px 10px 10px 10px;
  }

  .cph-wrap-shadow span {
    font-size: 18px;
  }

  .cph-wrap span {
    position: relative;
    text-align: center;
    width: 29.5px;
    height: 36px;
    border-radius: 2px;
    border: 1px solid #E1E1E1;
    margin-right: 0px;
    background-color: #fff;
    color: #222;
    z-index: 99;
  }

  .cph-wrap span:first-of-type {
    margin-left: 0;
  }

  .cph-wrap span:nth-of-type(8) {
    margin-right: 0;
  }

  .cph-wrap span:last-child::before {
    content: none;
  }

  .keyboard-wrap {
    z-index:1000;
    background: #f2f3f5;
    padding: 0 2px 0;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;    
    // border-top-right-radius: 20px;
    // border-top-left-radius: 20px;
    .keyboardHeader {
      display: flex;
      background-color: #fff;
      margin: 1px 2px 10px 2px;
      line-height: 40px;
      justify-content: space-between;
      align-items: center;
      .specials {
        font-size: 18px;
        margin-left: 12px;
        color: #222;
      }

      .kspecials {
        color: #ccc;
      }
      .kclose {
        color:#fff;
        background: #845f56;
        border-radius: 4px;
        box-shadow: 0 1px 2px #666;
        width: calc(10% - 4px);
        text-align: center;
        height: 36px;
        line-height: 36px;
        margin: 3px -8px 5px 0;
        font-size: 16px;
      }
      .close {
        padding-right: 10px;
        display: flex;
        justify-content: flex-end;

        span {
          // color: #999;
          text-decoration: none;
          display: block;
          width: 50px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          font-size: 16px;
          // background-color: #845f56;
          // color:#fff;
          // border-radius: 4px;
        }
      }
    }
  }

  .keyboard {
    display: flex;
    justify-content: center;
    flex-flow: row wrap;
    position: relative;

    span {
      background: #fff;
      border-radius: 4px;
      box-shadow: 0 1px 2px #666;
      width: calc(10% - 4px);
      text-align: center;
      height: 36px;
      line-height: 36px;
      margin: 0 2px 5px;
      font-size: 16px;
      
    }

    .k-kspecials {
        color: #ccc;;
      }
    
    .k-del {
      width: 40px;
      position: absolute;
      right: 2px;
      display: block;
      background-color: #845f56;
      color:#fff;
    }

    .k-del img {
      display: block;
      margin: 9px auto;
    }

    .k-done {
      width: 60px;
      position: absolute;
      right: 2px;
      display: block;
      background-color: #0084FF;
      color: #fff;
      font-weight: bold;
    }

    .k-done2 {
      left: 2px;
      width: 40px;
    }
  }

  .keyboard > div {
    display: flex;
  }

  .slide-enter-active, .slide-leave-active {
    transition: all .3s;
    opacity: 1;
    transform: translateY(0);
  }

  .slide-enter, .slide-leave-to {
    opacity: 0;
    transform: translateY(400px);
  }
}

.cph-box {
  position: relative;
  //margin: 15px auto;
  // background-color: #fff;
  // border-radius: 5px;
  // border-top-right-radius: 15px;
  // border-top-left-radius: 15px;
  overflow: hidden;

  .numtitle {    
    font-size: 18px;
    color: #222222;
    text-align: center;
    line-height: 40px;
    font-weight: normal;
  }
}

span.hide {
  opacity: 0;
}

.active_key {
  background-color: #000;
  opacity: 0.2;
}
</style>
